<template>
  <div class="footer-container">
    <div class="info-container">
      <div class="left-container">
        <div class="item" v-for="item in infoItems" :key="item.title">
          <div class="title">{{item.title}}</div>
          <a class="link" v-for="sub in item.list" :key="sub.href" :href="sub.href">
            {{sub.label}}
          </a>
        </div>
      </div>
      <div class="right-container">
        <h4>客户中心</h4>
        <h2>020-83912326-8249</h2>
        <div class="img-tag-container">
          <img src="https://www.way-s.cn/imgs/img16.png" alt="" />
          <img src="https://www.way-s.cn/imgs/img17.png" alt="" />
          <img src="https://www.way-s.cn/imgs/img18.png" alt="" />
        </div>
      </div>
    </div>
    <div class="bottom-code">
      {{bottomCode}}
      <a href="https://beian.miit.gov.cn" target="_blank">粤ICP备09206296号-1</a>
      <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010602007083" target="_blank">粤公网安备44010602007083号</a>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data () {
    return {
      bottomCode: `© 2009-${new Date().getFullYear()} 广州威尔森信息科技有限公司 版权所有`,
      infoItems: [
        {
          title: '服务与产品',
          list: [
            {
              href: '',
              label: '智域'
            },
            {
              href: 'https://i.way-s.cn',
              label: '智库'
            },
            {
              href: 'https://www.way-s.cn/i-Solutions.html',
              label: '智策'
            },
            {
              href: 'http://www.daas-auto.com',
              label: '达示数据'
            }
          ]
        },
        {
          title: '关于威尔森',
          list: [
            {
              href: 'https://www.way-s.cn/About-WAYS.html',
              label: '了解威尔森'
            },
            {
              href: 'https://www.way-s.cn/news.html',
              label: '威尔森观点'
            },
            {
              href: 'https://www.way-s.cn/Contact-Us.php',
              label: '联系我们'
            },
            {
              href: 'https://www.way-s.cn/Terms-and-Conditions.html',
              label: '法律条款'
            }
          ]
        },
        {
          title: '广纳贤士',
          list: [
            {
              href: 'https://www.way-s.cn/Experienced-Professional-Opportunities.html',
              label: '社会招聘'
            },
            {
              href: 'https://www.way-s.cn/Campus-Recruitment.html',
              label: '校园招聘'
            }
          ]
        }
      ],
      infoItems1: [
        {
          title: '关于威尔森',
          list: [
            {
              href: 'https://www.way-s.cn/About-WAYS.html',
              label: '了解威尔森'
            },
            {
              href: 'https://www.way-s.cn/news.html',
              label: '威尔森观点'
            },
            {
              href: 'https://www.way-s.cn/Contact-Us.php',
              label: '联系我们'
            },
            {
              href: 'https://www.way-s.cn/Terms-and-Conditions.html',
              label: '法律条款'
            }
          ]
        },
        // {
        //   title: '智策',
        //   list: [
        //     {
        //       href: 'https://www.way-s.cn/i-Solutions.html',
        //       label: '智策介绍'
        //     }
        //   ]
        // },
        {
          title: '智库',
          list: [
            {
              href: 'https://i.way-s.cn',
              label: '平台入口'
            }
          ]
        },
        {
          title: '达示数据',
          list: [
            {
              href: 'http://www.daas-auto.com',
              label: '平台入口'
            }
          ]
        },
        {
          title: '广纳贤士',
          list: [
            {
              href: 'https://www.way-s.cn/Experienced-Professional-Opportunities.html',
              label: '社会招聘'
            },
            {
              href: 'https://www.way-s.cn/Campus-Recruitment.html',
              label: '校园招聘'
            }
          ]
        }
      ]
    }
  },
  mounted () {

  },
  methods: {
    show () {
      console.log('show')
      this.showModal = true
    },
    hidden () {
      this.showModal = false
    }
  }
}
</script>

<style lang="less" scoped>
.footer-container {
  background-color: #4F4F4F;
  .info-container {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 28px;
    .left-container {
      display: flex;
      align-items: start;
      padding-top: 28px;
      .item {
        display: flex;
        flex-direction: column;
        margin-right: 50px;
        .title {
          font-size: 20px;
          color: #fff;
          margin-bottom: 2px;
          line-height: 34px;
          white-space: nowrap;
        }
        .link {
          font-size: 14px;
          color: #c9c9c9;
          line-height: 24px;
        }
      }
    }
    .right-container {
      text-align: right;
      h4 {
        font-size: 20px;
        color: #fff;
        font-weight: normal;
      }
      h2 {
        margin-top: 5px;
        font-size: 24px;
        color: #fff;
      }
      .img-tag-container {
        img {
          margin-right: 10px;
        }
      }
    }
  }
  .bottom-code {
    text-align: center;
    background: #424242;
    color: #9E9E9E;
    height: 28px;
    line-height: 28px;
    font-size: 12px;
    color: #9e9e9e;
    a {
      font-size: 12px;
      color: #9e9e9e;
    }
  }
  @media screen and (max-width: 1024px) {
    .info-container {
      flex-direction: column;
      .left-container {
        width: 100%;
        justify-content: space-around;
        .item {
          margin-right: 0;
          .title {
            font-size: 12px;
            color: #7F8593;
            font-weight: 600;
          }
          .link {
            font-size: 12px;
          }
        }
      }
      .right-container {
        h4 {
          font-size: 12px;
        }
        h2 {
          font-size: 12px;
        }
        .img-tag-container {
          img {
            margin-right: 10px;
          }
        }
      }
    }
    .bottom-code {
      line-height: initial;
      padding: 12px 35px;
    }
  }
}
@media screen and (max-width: 1024px) {
  .footer-container {
    padding-bottom: 64px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/FooterBottom.vue